<template>
  <div class="white_bg">
      <div class="addArea" v-if="showAdd">
        <div
          class="filter_config_container"
          :style="{ height: is_show ? '165px' : '85px' }"
        >
          <template v-for="item in filterConditionRef" :key="item.field">
            <div class="config_item">
              <div class="config_label">{{ item.field }} :</div>
              <div class="config_list flex flex_wrap">
                <span
                  :class="[
                    !filterSelectedData[item.field].selectedText
                      ? 'current'
                      : '',
                  ]"
                  @click="changeFilterSelectedData(item.field, config, '')"
                  style="padding: 0 10px"
                  >不限</span
                >
                <span
                  :class="[
                    filterSelectedData[item.field].selectedText == config.text
                      ? 'current'
                      : '',
                  ]"
                  v-for="config of item.list"
                  :key="config.text"
                  @click="
                    changeFilterSelectedData(item.field, config, config.text)
                  "
                  >{{ config.text }}</span
                >
              </div>
            </div>
          </template>
        </div>
        <div class="show_or_hide" @click="is_show = !is_show">
            <div class="show_or_hide_btn">
              <div>
                {{ is_show ? "点击收起" : "展开更多" }}
              </div>
              <div class="icon_sanjiao" :class="is_show?'zhankai':'shouqi'"></div>
            </div>
        </div>
          
          <div class="filter_result_container">
              <el-table
              empty-text="暂无数据,敬请期待。"
              :data="carData"
              :cell-class-name="'center'"
              :header-row-class-name="'center table_header'"
              >
                  <el-table-column v-for="attr of thRef" :label="attr.name" :prop="attr.type" :key="attr.type">
                      <template #default="scope">
                        <template v-if="attr.type == 'model_img'">
                          <img class="model_img" :src="scope.row[attr.type]" alt="">
                        </template>
                        <template v-else-if="attr.type == 'brand'">
                          {{ scope.row[attr.type] + scope.row.model_name }}
                        </template>
                        <span v-else :class="attr.class">
                        {{scope.row[attr.type] || '-'}}
                        </span>
                      </template>
                  </el-table-column>
                  <el-table-column label="">
                      <template #default="scope">
                          <div v-if="isCompare(scope.row.id)" class="changeModelBtn" @click="changeModel(scope.row.id, 'add')">
                            <!-- <span class="addPlus">+</span> -->
                            <span>加入竞品车型</span>
                          </div>
                          <div v-else class="changeModelBtn" @click="changeModel(scope.row.id, 'cancel')">
                            <!-- <span class="addPlus">x</span> -->
                            <span>取消关注</span>
                          </div>
                      </template>
                  </el-table-column>
              </el-table>
          </div>
      </div>    
  </div>
</template>

<script>
  import { ref, reactive, watch } from 'vue'
  import { getCarFilterConfig, getCarLibrary, addCompareCar, getCompareCarList, delCompareCar } from '@/api_drive'
  import { ElTable, ElTableColumn, ElLoading, ElMessage }  from 'element-plus'
  // import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
  // import 'swiper/css/swiper.css'
  // import 'swiper/dist/css/swiper.css'
//   , useRouter 
  import { useRoute } from 'vue-router'
  export default {
    name: 'competing',
    components: {
      ElTable,
      ElTableColumn,
      // ElPagination
    },
    // watch: {
    //   '$route' (to) {
    //     if (to.name == 'competing') {
    //       this.showList = false;
    //       this.showAdd = true;
    //     }
    //   }
    // },
    setup(){

      const showList = ref(false)
      const showAdd = ref(true)
      const route = useRoute()
            console.log(route.query)
      let { not_in_id }  = route.query
      //筛选项
      const filterConditionRef = ref([])
      // 筛选项选中的数据
      const filterSelectedData = reactive({})
      //tab签th
      const thRef = ref([
          {
            type: 'model_img',
            name: ''
          },
           {
            type: 'brand',
            name: '车型'
          },
           {
            type: 'energy_type_str',
            name: '能源'
          },
           {
            type: 'price',
            name: '指导价'
          },
          {
            type: 'total_score',
            name: '综合得分',
            class: 'orange'
          },
          {
            type: 'top',
            name: '综合排名',
            class: 'orange'
          }
      ])
      const compareIds = ref([]);
      const getCarFilterConfigData = () => {
        getCarFilterConfig().then(res=>{
          if(res.code == 200){
            const { condition } = res.data
            filterConditionRef.value = condition
            for(let item of condition){
              filterSelectedData[item.field] = {
                selectedText: '',
                params: {}
              }
            }
          }
        })
      }
      // 点击筛选项
      const changeFilterSelectedData = (type, data, selectedText) => {
        if(filterSelectedData[type].selectedText==selectedText){
          return
        }
        filterSelectedData[type].selectedText = selectedText
        if(data){
          filterSelectedData[type].params = data.params
        }else{
          filterSelectedData[type].params = {}
        }
        currentPage.value = 1
        count.value = 0
        getCarData()
      }
      const count = ref(0),
            currentPage = ref(1),
            pageSize = ref(9999),
            carData = ref([])

      const compareCount = ref(0),
            compareCurrentPage = ref(1),
            comparePageSize = ref(20),
            compareCarData = ref([])
            
      // 获取车型列表数据
      const getCarData = () => {
        const loading = ElLoading.service({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)',
        })
        const data = {
          page:currentPage.value,
          rows: pageSize.value,
        }
        if(not_in_id){
          data.not_in_id = not_in_id
        }
         //重新请求list
        let params = {}
        for(let key in filterSelectedData){
          Object.assign(params, filterSelectedData[key].params)
        }


        compareIds.value = [];
        getCompareCarList({size: 9999}).then(res => {
          if (res.data.list) {
            res.data.list.forEach(function(model){
              compareIds.value.push(parseInt(model.model_id))
            })
            //params['not_in_id'] = compareIds.value.join(',')
              getCarLibrary({
                ...data,
                ...params
              }).then(res => {
                if(res.code == 1){
                  count.value =  res.data.count
                  const list = res.data.list
                  if(data.first_id && list[0] && list[0].id == data.first_id){
                    list[0].isWarning = true
                  }
                  carData.value = list
                  
                }
                loading && loading.close()
              })
          }
        })

        
      }
      getCarFilterConfigData()
      getCarData()

      const getCompareCarData = () => {
        getCompareCarList({size: 9999}).then(res => {
          compareCarData.value = res.data.list
        })
      }
      getCompareCarData();
      
      // const initGetData = async () => {
      //   await getCarFilterConfigData()
      //   getCarData()
      // }
      // initGetData()
      // 点击页数时
      const handlePageChange = () => {
        getCarData()
      }
      // 返回传参问题
      const changeModel = (model_id, type) => {
        if (type == 'add') {
       
          addCompareCar({model_id: model_id}).then(res => {
            compareIds.value.push(model_id);
            if(res.code == 200){
              getCarData();
              ElMessage.success('添加成功!')
            } else {
              ElMessage.error(res.message || '添加失败!')
            }
          })
        } else {
          delCompareCar({model_id: model_id}).then(res => {
            if(res.code == 200){
              let index = compareIds.value.indexOf(model_id); 
              if (index > -1) { 
                compareIds.value.splice(index, 1); 
              } 
              if (type == 'cancelRefresh') {
                getCompareCarData();
              }
              ElMessage.success('添加成功!')
            } else {
              ElMessage.error(res.message || '添加失败!')
            }
          })
        }

      }
      const isCompare = (model_id) => {
        return compareIds.value.indexOf(model_id) == -1;
      }
      watch(compareIds.value, (a, b) => {
        console.log(a, b);
      });
      watch(showList, (a, b) => {
        if (b) {
          getCarData();
        }
      })
      watch(showAdd, (a, b) => {
        if (b) {
          getCompareCarData();
        }
      })
      const is_show = ref(false);
      return {
        filterConditionRef,
        filterSelectedData,
        thRef,
        count,
        currentPage,
        pageSize,
        carData,
        changeFilterSelectedData,
        handlePageChange,
        changeModel,
        isCompare,
        showAdd,
        showList,
        compareCount,
        compareCurrentPage,
        comparePageSize,
        compareCarData,
        is_show
      }
    },

  }
</script>

<style scoped lang="less">
.title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.addCompare{
  width: 133px;
  height: 35px;
  background: #FFFFFF;
  box-shadow: 0px 0px 6px 0px #BCD8FF;
  border-radius: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.addText {
  font-size: 16px;
  color: #7E7E7E;
  line-height: 21px;
}
.addIcon {
  width: 17px;
  height: 17px;
  border: 1px solid #3F8FFF;
  border-radius: 17px;
  color: #3F8FFF;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 12px;
}

.model_img{
  width: auto;
  height: 60px;
}
  
    .orange {
      font-size: 14px;
      // font-weight: bold;
      // color: #E7816E;
      line-height: 19px;
    }
    .addPlus {
      width: 16px;
      height: 16px;
      border: 1px solid #3F8FFF;
      border-radius: 16px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 5px;
    }
    .white_bg{
      width: 1090px;
      padding: 26px 53px 63px 53px;
    }
.filter_config_container {
  // width: 1090px;
  font-size: 14px;
  color: #474747;
  height: auto;
  transition: height 500ms;
  position: relative;
  overflow: hidden;
  .config_item {
    line-height: 32px;
  }
  .config_label {
    float: left;
    margin: 5px 0;
    color: #474747;
    font-weight: bold;
  }
  .config_list {
    margin-left: 62px;
    span {
      margin: 8px;
      display: inline-block;
      height: 26px;
      line-height: 26px;
      padding: 0 3px;
      white-space: nowrap;
      cursor: pointer;
     
      &:first-child {
        margin-left: 0;
      }
      &:hover {
        background: #ebefff;
        color: #474747;
      }
       &.current {
        background: #1FBCBF;
        color: #fff;
      }
    }
  }
}
    .filter_result_container{
      margin-top: 40px;
    }
    .changeModelBtn{
        cursor: pointer;
        color: #7d95f3;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    :deep(.el-tabs__header){
      margin-bottom: 0;
    }
    :deep(.el-tabs__nav-wrap::after){
      display: none;
    }
    :deep(.el-tabs__item){
      height: 45px;
      font-size: 15px;
        // &.is-active, &:hover{
        //   font-weight: bold;
        //   color: #00CDFF;
        // }
    }
    :deep(.el-tabs__active-bar){
      height: 3px;
      // background: #00CDFF;
      border-radius: 1px;
    }
    :deep(.center .cell){
      text-align: center;
      color: #474747;
    }
    :deep(.table_header th){
      background: #f5f7f9;
      font-weight: bold;
    }
    // .#F5F8FF{
    //   background: #F5F8FF;
    // }
    :deep(.el-pagination){
      margin-top: 40px;
      text-align: center;
      .btn-prev,.btn-next{
        display: inline-flex;
        align-items: center;
        justify-content: center;
      }
    }
.show_or_hide {
  width: 1090px;
  height: 29px;
  margin-left: -53px;
  border-radius:0 0 20px 20px;
  border-bottom: solid 1px #dee8f6;
  background: #fff;
  position: relative;
  .show_or_hide_btn{
    position: absolute;
    bottom: -10px;
    left: 50%;
    transform: translateX(-50%);
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100px;
    height: 20px;
    line-height: 20px;
    font-size: 15px;
    color: #969696;
    background: #fff;
    .icon_sanjiao{
      width: 10px;
      height: 10px;
      margin-left: 7px;
      background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/zksq_sanjiao.png) no-repeat center center;
      background-size: 8px;
      transition: all 500ms;
      &.shouqi{
        transform: rotateZ(180deg);
      }
    }
  }
}

</style>